import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { VehicleSettlementComponentComponent } from '../../components/vehicle-settlement-component/vehicle-settlement-component.component';
import { StorageService } from '../../services/storage.service';
import { ConnectionService } from 'src/app/services/connection.service';

@Component({
  selector: 'app-vehicle-quote-plan',
  templateUrl: './vehicle-quote-plan.page.html',
  styleUrls: ['./vehicle-quote-plan.page.scss'],
})
export class VehicleQuotePlanPage implements OnInit {
  finalPremium: any;
  vehicleSellingPrice: any;
  multiPrice: number;
  concentrateValue: number;
  minIdv: number;
  maxIdv: number;
  idvValue: string;
  forPassRes: any;
  vehicleModel: any;
  vehicleQuoteList: any = [];
  prodDetail: any;
  vehicleType = {
    "isBike": false,
    "isCar": false,
    "pageId": 0
  }
  constructor(private strg: StorageService, 
    private router: Router, 
    private modalCtrl: ModalController, 
    private apiService: ConnectionService,
    private route: ActivatedRoute,) {
  }

  ngOnInit() {
  }
  ionViewDidEnter() {
    this.route.params.subscribe(params => {
      let routeOne = params['vehicleType'];
      this.vehicleType.pageId = 1
      if (routeOne == "bike") {
        this.vehicleType.isBike = true;
        this.vehicleType.isCar = false;
      }
      else if (routeOne == "car") {
        this.vehicleType.isCar = true
        this.vehicleType.isBike = false;
      }
    })
    if(this.vehicleType.isCar === true){
      this.apiService.vehicleQuoteListArray.subscribe(quoteList => {
        if (quoteList.length === 0) {
          this.router.navigate(['/vehicle-quote-form/car']);
        }
        else {
          this.vehicleModel = quoteList[0].vehicleModel
          quoteList[0].respData.forEach(element => {
            // let qtres = JSON.parse(element.data)
            let qtres = element.data
            this.prodDetail = JSON.parse(qtres.publicUserQuoteDetails.productDetails)
            this.forPassRes = qtres
            this.vehicleModel = qtres.lombardQuoteResponse.generalInformation.manufacturerName + " " + qtres.lombardQuoteResponse.generalInformation.vehicleModel
            this.finalPremium = qtres.lombardQuoteResponse.finalPremium
            this.vehicleSellingPrice = qtres.lombardQuoteResponse.generalInformation.showRoomPrice
            this.multiPrice = this.vehicleSellingPrice * .5
            this.concentrateValue = this.multiPrice * 0.05
            this.minIdv = qtres.idvResponse.minidv //this.multiPrice - this.concentrateValue;
            this.maxIdv = qtres.idvResponse.maxidv //+this.multiPrice + this.concentrateValue;
            this.idvValue = this.minIdv.toFixed(0)
          })
          this.triggerPublicQuoteEmail()
        }
  
      })
    }
   
  }
  triggerPublicQuoteEmail() {
    setTimeout(() => {
      let reqData = {
        firstName: this.forPassRes.publicUserQuoteDetails.firstName,
        email: this.forPassRes.publicUserQuoteDetails.email,
        products: [],
      }
      reqData.products.push({
        productName: this.prodDetail.name,
        idvAmount: String(this.forPassRes.idvResponse.minidv),
        modelType: this.forPassRes.lombardQuoteResponse.generalInformation.manufacturerName + " " + this.forPassRes.lombardQuoteResponse.generalInformation.vehicleModel,
        insurerName: this.prodDetail.insuranceProvider.name,
        premiumAmount: String(this.finalPremium),
        vehicleType: this.vehicleModel
      })
      this.apiService.vehiclePublicQuoteEmailTrigger(reqData).subscribe(res => {
      })
    }, 1000);

  }
  routeTo() {
    this.router.navigate(['./vehicle-quote-confirmation'])
  }
  async openConfirmModal(cashless) {
    const modal = await this.modalCtrl.create({
      component: VehicleSettlementComponentComponent,
      componentProps: {
        dataSelected: this.forPassRes,
        cashlessOpen: cashless,
      },
      cssClass: "modal-settlement",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });
    return await modal.present();
  }
}
